export default __webpack_public_path__ + "static/media/img_05.f3f71b3f.svg";